import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import CareersHeader from '../../common/careers-header';
import CareersMobileMenu from '../../common/careers-mobile-menu';
import CareersFooter from '../../common/careers-footer';

import styles from './index.module.scss';
import ToTop from '../../common/to-top';

const CareersLayout = ({ className, children, activePage, ...other }) => {
	const skipTo = useRef();
	const [showMenu, setShowMenu] = useState(false);

	const onSkipContentClick = () => {
		skipTo.current.focus();
	};

	const onHamburgerClick = () => {
		setShowMenu(!showMenu);
	};

	return (
		<div id='pella-site-content'>
			<a href='#content' className={styles.skipContentLink} onClick={() => onSkipContentClick()}>
				Skip to Content
			</a>

			<CareersHeader showMenu={showMenu} activePage={activePage} onHamburgerClick={() => onHamburgerClick()} />

			<CareersMobileMenu showMenu={showMenu} activePage={activePage} closeMenu={() => onHamburgerClick()} />

			<div className={`${styles.content_GroupMobile} ${showMenu ? styles.content_GroupMobile_slide : ''}`}>
				<main id='content' className={`${styles.layout_Main} ${className || ''}`} ref={skipTo} {...other}>
					{children}
				</main>

				<ToTop />
				<CareersFooter />
			</div>
		</div>
	);
};

export default CareersLayout;

CareersLayout.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	activePage: PropTypes.object,
};
